module.exports = __webpack_public_path__ + "img/coconut-app-icon.3597f233.jpg";